'use strict';

module.exports = '2.26.0';



// WEBPACK FOOTER //
// ./~/instantsearch.js/~/algoliasearch-helper/src/version.js